import { render } from "./SocialDisplaySettings.vue?vue&type=template&id=7ece3226&scoped=true"
import script from "./SocialDisplaySettings.vue?vue&type=script&lang=js"
export * from "./SocialDisplaySettings.vue?vue&type=script&lang=js"

import "./SocialDisplaySettings.vue?vue&type=style&index=0&id=7ece3226&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ece3226"]])

export default __exports__